import $ from 'jquery'
import { isShow, isBg, isHide } from '../_variables'

export default class menuScroll {
  constructor() {
    this.elm = document.querySelector('html')
  }

  init() {
    this.menuScroll()
  }

  // scroll
  menuScroll() {
    $('.js-menuScroll').each((idx, elm) => {
      let $prevScrollpos = 0

      $(window).on('scroll', () => {
        const $this = $(elm)
        const $currentScrollPos = $(window).scrollTop()

        if ($currentScrollPos > $prevScrollpos && $currentScrollPos > 0 && $prevScrollpos > 0) {
          $this.addClass(isHide)
          $('.p-gnaviContent').fadeOut(200).removeAttr('style')
          $('.p-gnavi__item').removeClass(isShow)
          $('.l-header').removeClass(isBg)
        } else if ($currentScrollPos < $prevScrollpos) {
          $this.removeClass(isHide)
          if($currentScrollPos !== 0){
            $('.p-gnaviContent').fadeOut(200)
          }
        }

        $prevScrollpos = $currentScrollPos
      })
    })
  }
}
